<div class="wk-cm__card-panel__assignees">
    @if (type() === CardPanelType.Job) {
        <div class="wk-cm__card-panel__assignees-item" id="currentlyResponsible">
            <kendo-dropdownlist-wrapper
                [label]="'JobsAndBilling.AssignedRoles.CurrentlyResponsible' | translate"
                [data]="usersPerRole().get('currentlyResponsible') ?? []"
                formControlName="currentlyResponsible"
                textField="label"
                valueField="iFirmUserId"
                [virtual]="true"
                [readonly]="isRoleDisabled()('currentlyResponsible')"
                [tooltipIfReadonly]="(type() === CardPanelType.Job ? 'Tooltips.DisabledJobsSecurity' : 'Tooltips.DisabledPartnerManager') | translate"
            />
        </div>
    }
    @for (role of roles(); track role.Id) {
        @if (showRole()(role.Id)) {
            <div class="wk-cm__card-panel__assignees-item" [id]="(type() ?? 'assignee') + '_role_' + role.Id">
                @let roleField = fieldByRole().get(role.Id);
                @if (roleField) {
                    <kendo-dropdownlist-wrapper
                        [label]="labelByRole().get(roleField)"
                        [data]="usersPerRole().get(role.Id) ?? []"
                        [formControlName]="roleField"
                        textField="label"
                        valueField="iFirmUserId"
                        [virtual]="true"
                        [readonly]="isRoleDisabled()(role)"
                        [tooltipIfReadonly]="
                            (type() === CardPanelType.Job ? 'Tooltips.DisabledJobsSecurity' : 'Tooltips.DisabledPartnerManager') | translate
                        "
                    />
                }
            </div>
        }
    }
    @if (type() === CardPanelType.Job) {
        <div class="wk-cm__card-panel__assignees-item" id="jobOwner">
            <kendo-dropdownlist-wrapper
                [label]="'JobsAndBilling.AssignedRoles.JobOwner' | translate"
                [data]="usersPerRole().get('jobOwner') ?? []"
                formControlName="jobOwner"
                textField="label"
                valueField="iFirmUserId"
                [virtual]="true"
                [readonly]="isRoleDisabled()('jobOwner')"
                [tooltipIfReadonly]="(type() === CardPanelType.Job ? 'Tooltips.DisabledJobsSecurity' : 'Tooltips.DisabledPartnerManager') | translate"
            />
        </div>
    }
</div>
